/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import {
    Button,
    Divider,
    FormControl,
    InputLabel,
    MenuItem,
    TextField,
    Typography,
    Select,
    CircularProgress,
} from "@mui/material";
import Listboxes from "../ListBoxes/ListBoxes";
import customHttp from "../../services/customHTTP";
import Swal from "sweetalert2";

const NewUserForm = ({
    allCustomers,
    allSites,
    newUser,
    setNewUser,
    allUsers,
    setAllUsers,
    assignedSitesLoc,
    setAssignedSitesLoc,
    setCreateNewUser,
}) => {
    const [userSubmitLoading, setUserSubmitLoading] = useState(false);
    const [assignedSitesLoc1, setAssignedSitesLoc1] = useState([]);
    const [error, setError] = useState("");

    const handleAssignedSitesLocChange = (updatedAssignedSites) => {
        setAssignedSitesLoc1(updatedAssignedSites);
    };

    const handleUserCreateCancel = () => {
        setNewUser({
            user_first_name: "",
            user_last_name: "",
            user_email: "",
            user_phone: "",
            user_role: "",
            user_status: "0",
        });
        setAssignedSitesLoc([]);
        setCreateNewUser(false);
    };

    const handleUserCreateSubmit = async (e) => {
        e.preventDefault();
        setUserSubmitLoading(true);

        try {
            // Extract customer and sites into strings for API request
            const customers = assignedSitesLoc1.map((item) => item.customer).join(",");
            const sites = assignedSitesLoc1.flatMap((item) => item.sites).join(",");

            // Prepare request body
            const req_body = {
                ...newUser,
                user_customers: customers,
                user_sites: sites,
                user_display_name: `${newUser.user_first_name} ${newUser.user_last_name}`,
            };
            const response = await customHttp.post("/users/create", req_body);

            if (response.data.status === "success") {
                // Update allUsers with the new user
                setAllUsers((prevUsers) => [...prevUsers, response.data.user]);
                setTimeout(() => {
                    setUserSubmitLoading(false);
                    handleUserCreateCancel();
                    Swal.fire({
                        icon: "success",
                        title: "User Created Successfully!",
                        confirmButtonText: "Okay",
                    }).then((result) => {
                        setCreateNewUser(false);
                    });
                }, 1000);
            } else {
                setError("Failed to Create User: No product found.");
            }
        } catch (err) {
            setError("Failed to Create User: " + err.message);
        }
    };

    return (
        <>
            {/* <Divider sx={{ my: 2 }} /> */}
            <div className="user-edit-form">
                <Typography variant="h6" gutterBottom>
                    Create New User
                </Typography>
                <div className="edit-user-form">
                    <div className="user-details-section">
                        <Divider>User Details</Divider>

                        <form>
                            <div className="form-group">
                                <TextField
                                    label="First Name"
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    margin="normal"
                                    value={newUser.user_first_name}
                                    onChange={(e) => setNewUser({ ...newUser, user_first_name: e.target.value })}
                                />
                                <TextField
                                    label="Last Name"
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    margin="normal"
                                    value={newUser.user_last_name}
                                    onChange={(e) => setNewUser({ ...newUser, user_last_name: e.target.value })}
                                />
                                <TextField
                                    label="Email"
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    margin="normal"
                                    value={newUser.user_email}
                                    onChange={(e) => setNewUser({ ...newUser, user_email: e.target.value })}
                                />
                            </div>
                            <div className="form-group">
                                <TextField
                                    label="Phone"
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    margin="normal"
                                    value={newUser.user_phone}
                                    onChange={(e) => setNewUser({ ...newUser, user_phone: e.target.value })}
                                />
                                <FormControl variant="outlined" fullWidth size="small" margin="normal">
                                    <InputLabel>Role</InputLabel>
                                    <Select
                                        label="Role"
                                        value={newUser.user_role}
                                        onChange={(e) => setNewUser({ ...newUser, user_role: e.target.value })}>
                                        <MenuItem value="Admin">Admin</MenuItem>
                                        <MenuItem value="Viewer">Viewer</MenuItem>
                                        <MenuItem value="Purchaser">Purchaser</MenuItem>
                                    </Select>
                                </FormControl>

                                <FormControl variant="outlined" fullWidth size="small" margin="normal">
                                    <InputLabel>Status</InputLabel>
                                    <Select
                                        label="Status"
                                        value={newUser.user_status}
                                        onChange={(e) => setNewUser({ ...newUser, user_status: e.target.value })}>
                                        <MenuItem value="1">Approved</MenuItem>
                                        <MenuItem value="0">Pending</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                        </form>
                    </div>
                    <Divider>Customer Allocation</Divider>

                    <div className="user-customer-section">
                        <Listboxes
                            sites={allSites}
                            customers={allCustomers}
                            assignedSitesProp={assignedSitesLoc}
                            onAssignedSitesChange={handleAssignedSitesLocChange}
                        />
                    </div>
                </div>
                <div className="button-container">
                    <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        onClick={handleUserCreateSubmit}
                        disabled={!assignedSitesLoc1.length > 0}
                        sx={{ mt: 2 }}>
                        {userSubmitLoading ? (
                            <>
                                <CircularProgress size={24} sx={{ color: "white", marginRight: 1 }} />
                                Creating...
                            </>
                        ) : (
                            "Create User"
                        )}
                    </Button>
                    <Button variant="outlined" color="primary" onClick={handleUserCreateCancel} sx={{ mt: 2 }}>
                        Cancel
                    </Button>
                </div>
            </div>
        </>
    );
};

export default NewUserForm;
